/**
 * Shared SSE-down → poll fallback interval helper (admin SWR + inbox).
 * Connected → 0; disconnected → caller fallback ms.
 */
export function resolveSseDownRefreshInterval(
  realtimeConnected: boolean,
  fallbackRefreshIntervalMs: number,
): number {
  return realtimeConnected ? 0 : fallbackRefreshIntervalMs;
}
